module.exports = __webpack_public_path__ + "img/gb9877_1-88-16x30x7.prt.962d0e20.jpg";